module.exports = __webpack_public_path__ + "static/media/zw.c080cd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/zw.png
// module id = 2028
// module chunks = 0